import { requestJson, RequestParams, RequestResponse } from '@vfde-sails/utils';
import { LeadManagementForm, LeadManagementRequest, LeadManagementResponse } from '../interface';
import { getUrl } from '../../../util/url';
import { Address } from '@vfde-sails/avc-core';
import { isGender } from '../../../util/typeGuard';
import { Domains, Endpoints } from '../../../enum';
import { call } from '@redux-saga/core/effects';
import { getTimeStamp } from './date';
import { LeadManagementId } from '../enum';
import { getNotificationHeadlineText } from '../../../tracking/util';
import { trackAppError } from '../../../tracking/tracking';
import { isStagingEnv } from './../../../util/jarvisHelpers';

export const getLeadManagementRequest = (form: LeadManagementForm, address: Address) => ({
    title: isGender(form.title) ? form.title : '',
    timestamp: getTimeStamp(),
    firstName: form.firstName,
    lastName: form.lastName,
    email: form.email,
    city: address.city ?? '',
    street: address.street,
    houseNumber: address.housenumber,
    houseNumberExtra: address.housenumberextra,
    district: address.district?.toString(),
    zipcode: address.zipcode,
    referrer: window.location.host,
});

export function* postLeadManagementForm (form: LeadManagementForm, address: Address) {
    const url: string = isStagingEnv() ? yield call(getUrl, Domains.ST, Endpoints.LMS) : yield call(getUrl, Domains.ZUHAUSEPLUS, Endpoints.LMS);
    const payload: LeadManagementRequest = yield call(getLeadManagementRequest, form, address);
    const request: RequestParams = {
        headers: [
            ['Content-Type', 'application/json'],
        ],
        method: 'POST',
        body: JSON.stringify(payload),
    };

    const response: RequestResponse<LeadManagementResponse> = yield call(requestJson, url, request);

    return response.body;
}

export function* trackLeadManagementError () {
    const message: string = yield call(getNotificationHeadlineText, LeadManagementId.ERROR_NOTIFICATION);

    yield call(trackAppError, message);
}
